/** Google Analytics tag ID for this application. */
export const GOOGLE_TAG_ID = 'G-PW972FLHRZ';
